/**
 * Deployment environments. Each has its own D1 database, R2 bucket, secrets and
 * OAuth callback URL; `preview` must never point at production data.
 */
export const APP_ENVIRONMENTS = {
  LOCAL: 'local',
  PREVIEW: 'preview',
  PRODUCTION: 'production',
} as const

export type AppEnvironment = (typeof APP_ENVIRONMENTS)[keyof typeof APP_ENVIRONMENTS]

export const APP_ENVIRONMENT_VALUES = Object.values(APP_ENVIRONMENTS) as [
  AppEnvironment,
  ...AppEnvironment[],
]

/**
 * The dev password login path is only ever permitted here. Any other
 * environment must reject it even if the variable is somehow set.
 */
export function isDevAuthAllowedEnvironment(environment: AppEnvironment): boolean {
  return environment === APP_ENVIRONMENTS.LOCAL
}
